import { LOCALE_STORAGE_KEY, type PortalLocale } from './constants';

export const PORTAL_LOCALE_CHANGE_EVENT = 'portal-locale-change';

export function getStoredPortalLocale(): PortalLocale {
  if (typeof window === 'undefined') return 'ko';
  try {
    const raw = localStorage.getItem(LOCALE_STORAGE_KEY);
    if (raw === 'en' || raw === 'ko') return raw;
  } catch {
    /* ignore */
  }
  return 'ko';
}

export function notifyPortalLocaleChange(locale: PortalLocale): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(PORTAL_LOCALE_CHANGE_EVENT, { detail: locale }));
}
